import ProjectPropertyLookup, {SourceType} from "./project-property-lookup"
import ProjectStatusManager from "../../../gd/manager/project-status-manager"
import ProjectSession from "../project-session"

export default class ProjectStatusesLookup extends ProjectPropertyLookup {

    get() {
        let res = [];

        // 1. check if project has property and retrieve project statuses
        if (!!this.project.statuses) {
            res = this.getProjectStatuses(this.project);
            this.sourceType = SourceType.CUSTOM;
        }

        // 2. if project statuses not found yet check for template
        if (res.length === 0) {
            const template = gd.session.templatesList.get(this.project.localTemplateId)
            if (template) res = this.getProjectStatuses(template);

            // if result found then inherited from template
            if (res.length !== 0) {
                this.sourceType = SourceType.INHERITED;
                this.sourceProjectId = template.id;
            }
        }

        // 3. if task types still not found return default task types
        if (res.length === 0) {
            res = this.getDefaultProjectStatuses();
            this.sourceType = SourceType.GENERIC;
        }

        return _.map(res, s=>(this.isGeneric() ? s : gd.session.statuses.get(s)));
    }

    getProjectStatuses(project:ProjectSession) {
        let res = [];
        if ([
            gd.const.project.type.PROJECT,
            gd.const.project.type.BACKLOG,
            gd.const.project.type.SPRINT
        ].includes(project.systemType) && project.statuses) {
            res = project.statuses;
        }
        return res;
    }

    getDefaultProjectStatuses() {
        return ProjectStatusManager.getDefaultStatuses(null)
    }
}